<template>
	<div class="full-width">
		<v-tabs
			dark
			v-model="activeTab"
			slider-color="yellow"
			:color="themeInputColor"
		>
			<v-tab
				v-for="(tab, i) in tabs"
				:key="i"
				:href="'#' + tab.type"
				class="px-3"
			>
				{{ tab.name }}
			</v-tab>
		</v-tabs>

		<v-tabs-items v-model="activeTab" touchless>
			<v-tab-item :value="tabs[0].type">
				<v-container fluid fill-height class="pa-3">
					<data-table
						:headers="headers"
						:themeInputColor="themeInputColor"
						:fetchJeet11PartnerRechargeHistory="
							fetchJeet11PartnerRechargeHistory
						"
						:tabMetaData="tabs[0]"
						:openRechargeModal="openRechargeModal"
						:slicePhoneNo="slicePhoneNo"
					></data-table>
				</v-container>
			</v-tab-item>
			<v-tab-item :value="tabs[1].type">
				<v-container fluid fill-height class="pa-3">
					<data-table
						:headers="headers"
						:themeInputColor="themeInputColor"
						:fetchJeet11PartnerRechargeHistory="
							fetchJeet11PartnerRechargeHistory
						"
						:tabMetaData="tabs[1]"
						:openRechargeModal="openRechargeModal"
						:slicePhoneNo="slicePhoneNo"
					></data-table>
				</v-container>
			</v-tab-item>
		</v-tabs-items>
		<v-dialog width="600px" persistent v-model="transferJeet11Dialog">
			<div class="white-bg pa-4 pos-rel">
				<transfer-money
					model="transferJeet11Dialog"
					:themeInputColor="themeInputColor"
					:jeet11User="jeet11User"
					:payingJeet11User="pay11Jeet11UserLoading"
					:forgetMpin="forgetMpin"
					@CLOSE_MODAL="closeModal"
					:confirmAndPayJeet11User="confirmAndPayJeet11User"
				/>
			</div>
		</v-dialog>
		<generate-mpin
			@CLOSE_MODAL="closeModal"
			model="generateMpinDialog"
			v-if="generateMpinDialog"
			:themeInputColor="themeInputColor"
		/>
	</div>
</template>

<script>
import { themeInputColor } from "@/utils";
import {
	FETCH_JEET11_PARTNER_RECHARGE_HISTORY,
	PAY_JEET11_USER
} from "@/store/action-types";
import { TOP, END } from "@/store/config";
import DataTable from "./DataTable";
import TransferMoney from "./TransferMoney";
import GenerateMPIN from "../GenerateMPIN";
import EventsManager from "@/event-manager";
export default {
	mounted() {
		this.fetchNewRechargeHistories();
		EventsManager.sendEvent({
			name: "RECHARGE_HISTORY_VISITED"
		});
	},
	components: {
		"data-table": DataTable,
		"transfer-money": TransferMoney,
		"generate-mpin": GenerateMPIN
	},
	name: "RechargeHistory",
	data() {
		return {
			END,
			TOP,
			fetchingRechargeHistory: {
				new: false,
				old: false
			},
			activeTab: "old",
			themeInputColor,
			tabs: [
				{ name: "Old Users", type: "old" },
				{ name: "New Users", type: "new" }
			],
			headers: [
				{
					text: "Updated On",
					value: "updatedOn",
					align: "center",
					sortable: false
				},
				{
					text: "Team Name",
					value: "teamName",
					align: "center",
					sortable: false
				},
				{
					text: "Deposit Balance",
					value: "depositBalance",
					align: "center",
					sortable: false
				},
				{
					text: "Phone No",
					value: "phoneNo",
					align: "center",
					sortable: false
				},
				{
					text: "Contact",
					value: "phoneNo",
					align: "center",
					sortable: false
				},
				{
					text: "Recharge",
					value: "recharge",
					align: "center",
					sortable: false
				},
				{
					text: "User History",
					value: "userHistory",
					align: "center",
					sortable: false
				}
			],
			jeet11User: null,
			transferJeet11Dialog: false,
			pay11Jeet11UserLoading: false,
			generateMpinDialog: false
		};
	},
	methods: {
		fetchNewRechargeHistories() {
			this.fetchJeet11PartnerRechargeHistory({ type: TOP, new: true });
			this.fetchJeet11PartnerRechargeHistory({ type: TOP, new: false });
		},
		fetchJeet11PartnerRechargeHistory(payload) {
			const customersType = payload.new ? "new" : "old";
			if (!this.fetchingRechargeHistory[customersType]) {
				this.fetchingRechargeHistory[customersType] = true;
				this.$store
					.dispatch(
						FETCH_JEET11_PARTNER_RECHARGE_HISTORY.dispatch,
						payload
					)
					.catch(() => {})
					.then(() => {
						this.fetchingRechargeHistory[customersType] = false;
					});
			}
		},
		openRechargeModal(jeet11User) {
			this.jeet11User = {
				...jeet11User,
				phoneNo: this.slicePhoneNo(jeet11User.phoneNo)
			};
			this.transferJeet11Dialog = true;
			EventsManager.sendEvent({
				name: "RECHARGE_HISTORY_RECHARGE_CLICKED",
				properties: {
					jeet11UserId: jeet11User.userId
				}
			});
		},
		closeModal(payload) {
			this[payload] = false;
		},
		confirmAndPayJeet11User(payload) {
			if (!this.pay11Jeet11UserLoading) {
				this.pay11Jeet11UserLoading = true;
				return this.$store
					.dispatch(PAY_JEET11_USER.dispatch, payload)
					.catch(() => {})
					.then(() => {
						this.pay11Jeet11UserLoading = false;
						this.transferJeet11Dialog = false;
						this.fetchNewRechargeHistories();
						EventsManager.sendEvent({
							name: "RECHARGE_HISTORY_SUCCESSFUL_RECHARGE",
							properties: {
								jeet11UserId: payload.userId
							}
						});
					});
			}
		},
		forgetMpin() {
			this.generateMpinDialog = true;
		},
		slicePhoneNo(phoneNo) {
			return phoneNo ? phoneNo.toString().slice(2) : phoneNo;
		}
	},
	watch: {
		activeTab(newVal) {
			EventsManager.sendEvent({
				name: "RECHARGE_HISTORY_TAB_CHANGED",
				properties: {
					type: newVal
				}
			});
		}
	}
};
</script>

<style scoped>
.white-bg {
	background: #fff;
}
</style>
